







































































































































































import TabsInfoMixin from '../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import { setDeviceProperty } from '@/modules/ApiUsers';
import { Watch } from 'vue-property-decorator';
import { invalidateFixtureTabCache } from '@/views/services/fixtureDetailsApi';
import { RETROFIT_STATE, PARTIAL_RETROFIT_STATE, PENDING_VERIFICATION_SYS_ACTIVE } from '@/modules/retrofitActions';

@Component({})
class AdvancedTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Global.State('readonly_user') readonly_user;
  @Global.State('lang') lang;
  @Global.State('timezone') projectTimezone;

  // @ts-ignore
  @Prop() device;
  @Prop() mqtt;
  @Prop() propsList;
  @Prop() deviceStreams;
  @Prop() deviceFixture;
  @Prop() statusFromMQTT;
  @Prop() showTemp;
  @Prop() deviceTemp;
  @Prop() mqtt_version;

  dataToShowTondo = {
    id: null,
    name: null,
    hardware_id_and_mac: null,
    driver_type: null,
    providers: null,
    location: null,
    ip_address: null,
    has_schedule: null,
    config: null,
    cellid: null,
    rssi: null,
    sys___connected: null,
    sys___active: null,
    allegro_flag: null,
    celular_status: null
  };
  format_titles = ['id', 'name', 'hardware_id_and_mac', 'driver_type', 'location', 'ip_address', 'has_schedule', 'config'];
  selectedAction = '';
  actionItemsList: any = {};
  hardwareidProp = null;
  scheduleProp = null;
  configProp = null;
  providersProp = null;
  actionsListProp = null;
  disconnectAlert = null;
  cellularStatus = null;
  allegroFlag = null;
  driverProp = null;
  language = null;
  ip_address = null;
  loading = false;
  commandLoading = false;
  commandTimeoutHandle = null;
  prop_utils = PropUtils;
  
  async mounted() {
    this.language = this.lang;
    this.loading = true;
    this.loadDriverAndCellular();
    this.loadProperties();
    await this.loadDataToShow();
    this.loading = false;
  }

  @Watch('statusFromMQTT')
  onStatusFromMQTTChanged() {
    // Stop loading when new message is received
    if (this.commandLoading) {
      this.commandLoading = false;
      this.clearCommandTimeout();
    }
  }

  beforeDestroy() {
    this.clearCommandTimeout();
  }

  loadDriverAndCellular() {
    // meta.driver (allegro flag) comes from the reporting propsList; the
    // cellular_status stream comes from the reporting deviceStreams. Both are
    // fetched in the single tab reporting query — no extra /properties or
    // /streams dump here.
    const driverProp = this.propsList && this.propsList.results
      ? this.propsList.results.find((el) => el.name === 'meta.driver')
      : null;
    if (driverProp && driverProp.value && driverProp.value.hasOwnProperty('dali')) {
      this.driverProp = driverProp.value;
      this.allegroFlag = driverProp.value.dali.toString();
    }

    const cellular = Utils.getStream('cellular_status', this.deviceStreams);
    if (cellular && cellular.value) {
      const cellularS =
        typeof cellular.value === 'string'
          ? JSON.parse(cellular.value.replaceAll(`'`, `"`))
          : cellular.value;
      if (
        cellularS &&
        typeof cellularS === 'object' &&
        cellularS.hasOwnProperty('state')
      ) {
        this.cellularStatus = cellularS.state;
      } else {
        const cellularS2 = JSON.parse(cellularS);
        if (
          cellularS2 &&
          typeof cellularS2 === 'object' &&
          cellularS2.hasOwnProperty('state')
        ) {
          this.cellularStatus = cellularS2.state;
        }
      }
    }
  }

  changeAllegroFlag(value) {
    const newDriverProp = {
      ...this.driverProp,
      dali: value === 'false' ? false : true
    };
    setDeviceProperty(this.device.id, 'meta.driver', newDriverProp).then(
      (res) => {
        this.dataToShowTondo.allegro_flag = value;
        this.driverProp = newDriverProp;
        // meta.driver changed — drop cached tab snapshots so a reopen re-fetches.
        invalidateFixtureTabCache(this.device.id);
      }
    );
  }

  loadProperties() {
    const hardwareidProp = this.propsList.results.find((el) => el.name === 'device.hardwareid');
    this.hardwareidProp = hardwareidProp ? hardwareidProp.value : null;

    const scheduleProp = this.propsList.results.find((el) => el.name === 'device.schedule');
    this.scheduleProp = scheduleProp ? scheduleProp.value : null;

    const providersProp = this.propsList.results.find((el) => el.name === 'meta.provider_id');
    this.providersProp = providersProp ? providersProp.value : null;

    const configProp = this.propsList.results.find((el) => el.name === 'device.config');
    this.configProp = configProp ? configProp.value : null;

    const ip_address = this.propsList.results.find((el) => el.name === 'meta.ipaddress');
    this.ip_address = ip_address && ip_address.value && ip_address.value.ipaddress ? ip_address.value.ipaddress : null;

    const actionsListProp = this.propsList.results.find((el) => el.name === 'dashboard.stream_commands');
    this.actionsListProp = actionsListProp ? actionsListProp.value : null;

    if (this.actionsListProp && this.actionsListProp.command) {
      const obj = {};
      this.actionsListProp.command.forEach((el) => {
        obj[el['name']] = el['value'];
      });
      this.actionItemsList = obj;
    }
    
    // Add DALI commands for specific device classes
    const className = this.device.class_name;
    if (className && (className === 'NB_BLE_nRF52V2' || className === 'SC220_NEMA' || className === 'SC220_ZHAGA')) {
      this.actionItemsList['Get DALI Topology'] = 'AT+dalitopology?';
      this.actionItemsList['Get DALI Scan Results'] = 'AT+daliscan?';
    }
  }

  async loadDataToShow() {
    try {
      let streamActive = Utils.getStream('sys___active', this.deviceStreams);
      streamActive = streamActive ? streamActive.value : null;
      let streamConnected = Utils.getStream('sys___connected', this.deviceStreams);
      streamConnected = streamConnected ? streamConnected.value : null;
      const stremCellid = Utils.getStream('cellid', this.deviceStreams);
      const streamRssi = Utils.getStream('rssi', this.deviceStreams);
      const sysActiveChangeTime = this.getStreamChangeTime('sys___active');
      const sysConnectedChangeTime = this.getStreamChangeTime('sys___connected');

      this.dataToShowTondo = {
        id: this.device.id,
        name: this.device.name,
        hardware_id_and_mac:
          typeof this.hardwareidProp === 'string'
            ? JSON.parse(this.hardwareidProp)
            : this.hardwareidProp,
        driver_type: this.deviceFixture
          ? this.deviceFixture['type']
          : 'N/A',
        providers: this.providersProp || null,
        location: Utils.deviceLocation(this.device),
        ip_address: this.ip_address,
        has_schedule:
          this.scheduleProp &&
          this.scheduleProp.schedule &&
          this.scheduleProp.schedule.length > 0
            ? 'Yes'
            : 'No',
        config: this.configProp
          ? typeof this.configProp === 'string'
            ? JSON.parse(this.configProp)
            : this.configProp
          : 'N/A',
        cellid: stremCellid ? stremCellid['value'] : 'N/A',
        rssi: streamRssi ? streamRssi['value'] : 'N/A',
        sys___connected: streamConnected !== null
          ? streamConnected === 1
            ? `${this.$t('Connected')} ${this.$t('since')} ${sysConnectedChangeTime}`
            : streamConnected === 0 
            ? `${this.$t('Disconnected')} ${this.$t('since')} ${sysConnectedChangeTime}`
            : this.$t('N/A')
          : this.$t('N/A'),
        sys___active: streamActive !== null
            ? streamActive === 1
              ? `${this.$t('Active')} ${this.$t('since')} ${sysActiveChangeTime}`
              : streamActive === 0 
              ? `${this.$t('Inactive')} ${this.$t('since')} ${sysActiveChangeTime}`
              : streamActive === -1 
              ? `${this.$t('Maintenance')} ${this.$t('since')} ${sysActiveChangeTime}`
              : streamActive === -3
              ? `${this.$t('In Installation')} ${this.$t('since')} ${sysActiveChangeTime}`
              : streamActive === -9
              ? `${this.$t('Fault In Care')} ${this.$t('since')} ${sysActiveChangeTime}`
              // The sentinel a device carries after being returned from Retrofit until it
              // reconnects - a connectivity value, not an operation state.
              : streamActive === PENDING_VERIFICATION_SYS_ACTIVE
              ? `${this.$t('Pending Verification')} ${this.$t('since')} ${sysActiveChangeTime}`
              : this.$t('N/A')
            : this.$t('N/A'),
        allegro_flag: this.allegroFlag ? this.allegroFlag : 'N/A',
        celular_status:
          this.cellularStatus !== null ? this.cellularStatus : 'N/A'
      };
    } catch (error) {
      console.log('error while assign dataToShow values', error);
    }
  }

  getStreamChangeTime(stream_name) {
    // last-changed time comes from the reporting `<stream>__modified` column
    // (epoch-seconds), surfaced on the deviceStreams entry as last_modified.
    // Fall back to the device prop's __modified field if present.
    const stream = Utils.getStream(stream_name, this.deviceStreams);
    const modified = stream && stream.last_modified !== undefined && stream.last_modified !== null
      ? stream.last_modified
      : this.device[`${stream_name}__modified`];
    return modified
      ? Utils.convertTimestamp(Math.floor(Number(modified) * 1000), 'DD.MM.YYYY HH:mm', this.projectTimezone)
      : this.$t('N/A');
  }

  get isActionSelected() {
    return this.selectedAction.length > 0;
  }

  get retrofitStatusLabel() {
    const operation_state = Utils.getOperationState(this.device);

    if (operation_state === RETROFIT_STATE) {
      return 'Retrofit';
    }
    if (operation_state === PARTIAL_RETROFIT_STATE) {
      return 'Partial Retrofit';
    }
    if (Utils.isPendingVerification(this.device)) {
      return 'Pending Verification';
    }

    return '';
  }

  get isRetrofitFixture() {
    return !!this.retrofitStatusLabel;
  }

  // Map-wide "see-through" toggle (GMap.vue toggleRetrofitSeeThrough) -
  // while on, the real sys___connected / sys___active values are unlocked.
  get retrofitSeeThrough() {
    return this.$store.state.MapSettings.retrofitSeeThrough;
  }

  get retrofitDataHidden() {
    return this.isRetrofitFixture && !this.retrofitSeeThrough;
  }

  // sys___connected / sys___active reflect real-world connectivity that
  // isn't meaningful while a device is out for Retrofit, so they're hidden
  // unless see-through mode is on.
  get visibleDataEntries() {
    const hidden_keys = ['sys___connected', 'sys___active', 'has_schedule', 'cellid', 'rssi', 'allegro_flag', 'celular_status'];
    return Object.entries(this.dataToShowTondo).filter(
      ([key]) => !(this.retrofitDataHidden && hidden_keys.includes(key))
    );
  }

  // getDeviceTemperature() {
  //   this.publishMqttMessage('AT+m=AT+QTEMP', 'command');
  // }

  runSelectedAction() {
    if (!this.selectedAction) {
      console.log('action is not selected');
    } else {
      this.commandLoading = true;
      this.publishMqttMessage(
        this.actionItemsList[this.selectedAction],
        'command'
      );
      // Set 10 second timeout
      this.clearCommandTimeout();
      this.commandTimeoutHandle = setTimeout(() => {
        this.commandLoading = false;
      }, 10000);
    }
  }

  clearCommandTimeout() {
    if (this.commandTimeoutHandle) {
      clearTimeout(this.commandTimeoutHandle);
      this.commandTimeoutHandle = null;
    }
  }

  publishMqttMessage(message, streamName) {
    const mqtt_publish_data = {
      version_num: this.mqtt_version,
      device_id: this.device.id,
      stream_id: this.mqtt_version === 3 ? `${this.device.id}.${streamName}` : streamName,
      message_type: 'cmd',
      format: 'minimal',
      stream_value: message,
      options: {
        retain: false,
        qos: 1
      }
    };

    this.mqtt.publishToSingleDevice(mqtt_publish_data);
  }
  @Watch('lang')
  setLang() {
    this.language = this.lang;
  }
}

export default AdvancedTab;
